import {
  CommunicationListResult,
  DocumentGetResponse,
  DocumentResultType,
  FaxGetResponse,
  LetterGetResponse,
} from "../";

import { DOCUMENT_METHOD_LABEL } from "../document/DocumentConstants";

export interface CaseDocumentListResult {
  readonly communications: ReadonlyArray<CommunicationListResult>;
  readonly document: DocumentGetResponse;
  readonly inbound_fax: FaxGetResponse;
  readonly letter: LetterGetResponse;
  readonly result_type: DocumentResultType;
}

export const CASE_DOCUMENT_METHODS = {
  ...DOCUMENT_METHOD_LABEL,
  phone: "Phone",
};
